<script setup lang="ts">
/**
 * Group table cell: weekly schedule template, one "<day> <start>–<end>" line
 * per slot — mirrors the sketch's `.sched`/`.sl`. `lines` arrives
 * pre-formatted (day label + time range already resolved) so this stays a
 * dumb renderer, matching `PerformerStatCell`'s convention.
 */
import { useI18n } from 'vue-i18n'

defineProps<{
  /** One pre-formatted line per schedule slot, e.g. "пн 18:30–20:00". */
  lines: string[]
  /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
  maxWidth?: string
}>()

const { t } = useI18n()
</script>

<template>
  <td
    class="group-schedule-cell font-tufte-sans"
    :style="maxWidth ? { maxWidth: maxWidth, overflowWrap: 'break-word' } : undefined"
  >
    <div v-if="lines.length" class="group-schedule-cell__list">
      <span v-for="(line, i) in lines" :key="i" class="group-schedule-cell__line">{{ line }}</span>
    </div>
    <span v-else class="group-schedule-cell__none">{{ t('cards.group.noSchedule') }}</span>
  </td>
</template>

<style scoped>
.group-schedule-cell__list {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.group-schedule-cell__line {
  font-family: var(--font-tufte-mono);
  font-size: var(--text-tufte-xs);
  color: var(--color-tufte-text);
}

.group-schedule-cell__none {
  font-family: var(--font-tufte-sans);
  font-size: var(--text-tufte-xs);
  color: var(--color-tufte-muted);
  font-style: italic;
}
</style>
